import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ParadigmaTable from "../../../../components/ParadigmaTable/";
import api from '../../../../api/';

import DestacadosModal from './Modal.js';
import ItemOrderUpdateModal from '../../../../components/ItemOrderUpdateModal/ItemOrderUpdateModal';

class Destacados extends Component {
    constructor(props) {
        super(props);
        this.refTable = React.createRef();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Descripción",
                    id: "Nombre",
                    accessor: "Nombre",
                    show: true,
                },
                {
                    Header: "Cantidad de Artículos",
                    id: "CantidadArticulos",
                    accessor: "CantidadArticulos",
                    show: true,
                    style: { textAlign: "center" },
                    filterable: true,
                    width: 150,
                },
                {
                    Header: "",
                    id: "link",
                    accessor: "link",
                    Cell: d => (<div className="pl-4"><a target="_blank" href={d.original.link} title="Ir a Página"><i class="fa fa-share" aria-hidden="true"></i></a></div>),
                    show: true,
                    private: true,
                    filterable: false,
                    sortable: false,
                    width: 50,
                }
            ],
        };
    }

    static propTypes = {
        additionalFields: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            onGet: PropTypes.string.isRequired, // (data: data que llega del servidor) => objeto: { key: value } lo que retorna se setea en el estado
            onPost: PropTypes.string.isRequired, // (data: data del estado que se envia al servidor) => objeto: { key: value } lo que se envia al servidor
            Input: PropTypes.func.isRequired, // (state, setThis, disabled, error) => <Input />
        })),
    }

    render() {
        const { additionalFields } = this.props;
        const { modernTheme } = this.props;

        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                    {
                        create: true,
                        component: (props) => <DestacadosModal {...props} action="CREATE" additionalFields={additionalFields} />,
                        permission: "ecommerce_articulos_destacados_new",
                    },
                    {
                        edit: true,
                        component: (props) => <DestacadosModal {...props} action="EDIT" additionalFields={additionalFields} />,
                        permission: "ecommerce_articulos_destacados_edit",
                    },
                    {
                        detail: true,
                        component: (props) => <DestacadosModal {...props} action="DETAIL" additionalFields={additionalFields} />,
                        permission: "ecommerce_articulos_destacados_detail",
                    },
                    {
                        delete: true,
                        component: (props) => <DestacadosModal {...props} action="DELETE" additionalFields={additionalFields} />,
                        permission: "ecommerce_articulos_destacados_delete",
                    },
                    {
                        detail: true,
                        component: () => <ItemOrderUpdateModal {...{
                            url: api.gestion.articulos.destacados.destacados,
                            type: "ArticulosDestacados",
                            nameField: "Nombre",
                            pkField: "id",
                            orderField: "Orden"
                        }} />,
                        permission: "ecommerce_articulos_destacados_edit",
                    },

                ]}
                apiUrl={api.gestion.articulos.destacados.destacados}
                columns={this.state.columns}
                title={"Destacados"}
                ref={this.refTable}
                innerRef={this.refTable}
            />
        );
    }
}

export default Destacados;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Destacados/Destacados.js